import withFlightResultsContext from '../withFlightResultsContext';
import { default as FlightsResultsProvidersComponent } from '../clientState/providers';

export default withFlightResultsContext(FlightsResultsProvidersComponent);
